import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import { browserHistory } from 'react-router';

class SendButton extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    if(this.props.onClick){
      this.props.onClick()
    }
  }

  render() {
    const { className } = this.props
    return (
      <button 
        className={cx(styles.button, className, {[styles.primary]: this.props.primary})} 
        onClick={this.handleClick} 
        disabled={this.props.disabled}
        type={this.props.type}>
        {this.props.icon && 
          <i className={cx("fa", this.props.icon)} aria-hidden="true"></i>
        }
        <span className={styles.title}>{this.props.title}</span>
      </button>
    );
  }
}

SendButton.defaultProps = {
  type: 'button'
}

export default SendButton;
